var _circle, _circle2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35.2809,
    fill: "url(#paint0_linear_689_1916)",
    fillOpacity: 0.2,
    stroke: "url(#paint1_linear_689_1916)",
    strokeWidth: 0.438272
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.4998,
    r: 28.7068,
    fill: "url(#paint2_linear_689_1916)",
    fillOpacity: 0.5,
    stroke: "url(#paint3_linear_689_1916)",
    strokeWidth: 0.438272
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7467 25.9866C48.1212 26.3616 48.3316 26.87 48.3316 27.4C48.3316 27.93 48.1212 28.4383 47.7467 28.8133L31.488 45.072C31.3003 45.2595 31.0772 45.4078 30.8316 45.5082C30.586 45.6087 30.3229 45.6592 30.0576 45.657C29.7923 45.6548 29.5301 45.5998 29.2863 45.4952C29.0424 45.3906 28.8218 45.2386 28.6373 45.048L22.2293 38.424C21.8639 38.0421 21.6645 37.5311 21.6746 37.0027C21.6848 36.4743 21.9037 35.9713 22.2836 35.6038C22.6634 35.2363 23.1733 35.0341 23.7018 35.0413C24.2303 35.0486 24.7344 35.2648 25.104 35.6426L30.0987 40.8053L44.92 25.9866C45.295 25.6121 45.8033 25.4017 46.3333 25.4017C46.8633 25.4017 47.3717 25.6121 47.7467 25.9866Z",
    fill: "#30C255"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_689_1916",
    x1: 35.5,
    y1: 3.28704,
    x2: 35.7772,
    y2: 104.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#299E47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300199,
    stopColor: "#299E47",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#299E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_689_1916",
    x1: 35.5,
    y1: 0,
    x2: 35.5,
    y2: 87.2161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41464D",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_689_1916",
    x1: 35.5,
    y1: 6.57385,
    x2: 36.6751,
    y2: 98.3831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#299E47",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356773,
    stopColor: "#299E47",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#299E47",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_689_1916",
    x1: 35.5,
    y1: 6.57385,
    x2: 35.5,
    y2: 64.4257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA7CD",
    stopOpacity: 0.06
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.400512dfe425160a9efcd5beb6e7ccb7.svg";
export { ForwardRef as ReactComponent };